import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '../../services/auth0/react-auth0.spa';
import { Spinner } from 'components/core';
import { debugLog } from 'shared/logger/debugLog';

const RedirectUnauthorized = (): React.ReactElement => {
  const { isAuthenticated, loading } = useAuth0();

  // Wait for Auth0 to finish initializing before making routing decisions
  if (loading || isAuthenticated === undefined) {
    return (
      <Spinner reason={`RedirectUnauthorized, loading: ${loading}`} />
    );
  }

  debugLog(
    'RedirectUnauthorized: is user authenticated? ',
    isAuthenticated
  );

  return <Navigate to='/login' />;
};

export default RedirectUnauthorized;
